import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import Box from '../../core/components/Box'
import {updateOpenTicketClaimCmd} from '../actions'
import i18n from '../i18n'
import TicketClaimStream from './TicketClaimStream'

function openCmdUpdate() {
    return {
        ticketUid: undefined,
        commandType: 'OpenTicketClaimOnExternalTicket'
    }
}

class TicketClaimStreamLayout extends Component {
    static propTypes = {
    }

    _navigate() {
        const {dispatch} = this.props

        const update = openCmdUpdate()
        dispatch(updateOpenTicketClaimCmd(update))
        
        return dispatch(push('/claims/new'))
    }

    render() {
        const {dispatch, _links} = this.props

        const newTicketClaimBoxTitle = (
            <h3>{i18n.newTicketClaim}</h3>
        )

        return (
            <Row>
                <Col sm={4} smPush={8}>
                    {_links.find(linkFinder(['OpenTicketClaim', 'OpenTicketClaimOnExternalTicket'])) && (
                        <Box
                            status='danger'
                            header={newTicketClaimBoxTitle}
                            help='+'
                            onClick={() => this._navigate()}>
                        </Box>
                    )}
                </Col>
                <Col sm={8} smPull={4}>
                    <TicketClaimStream />
                </Col>
            </Row>
        )
    }
}

TicketClaimStreamLayout = connect((state) => ({
    _links: state.claim._links
}))(TicketClaimStreamLayout)

export default TicketClaimStreamLayout


// WEBPACK FOOTER //
// ./lib/claim/components/TicketClaimStreamLayout.js